class ReviewsParallax {
  constructor(section) {
    this.section = section;
    this.firstColumn = section.querySelector('[data-reviews-column="first"]');
    this.secondColumn = section.querySelector('[data-reviews-column="second"]');
    this.scrollDistance = Number(section.dataset.scrollDistance || 120);
    this.scrollSpeed = Number(section.dataset.scrollSpeed || 100) / 100;
    this.mobileBehavior = section.dataset.mobileBehavior || 'stacked';
    this.mobileQuery = window.matchMedia('(max-width: 768px)');
    this.raf = null;

    this.handleUpdateRequest = () => this.requestUpdate();

    window.addEventListener('scroll', this.handleUpdateRequest, { passive: true });
    window.addEventListener('resize', this.handleUpdateRequest);

    if (typeof this.mobileQuery.addEventListener === 'function') {
      this.mobileQuery.addEventListener('change', this.handleUpdateRequest);
    } else if (typeof this.mobileQuery.addListener === 'function') {
      this.mobileQuery.addListener(this.handleUpdateRequest);
    }

    this.requestUpdate();
  }

  shouldAnimate() {
    return !this.mobileQuery.matches;
  }

  requestUpdate() {
    if (this.raf) return;
    this.raf = window.requestAnimationFrame(() => this.update());
  }

  update() {
    this.raf = null;

    if (!this.firstColumn || !this.secondColumn) {
      return;
    }

    if (!this.shouldAnimate()) {
      this.clearTransforms();
      return;
    }

    const rect = this.section.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const total = viewportHeight + rect.height;
    const visibleProgress = (viewportHeight - rect.top) / total;
    const clampedProgress = Math.min(Math.max(visibleProgress, 0), 1);
    const offset = (clampedProgress - 0.5) * this.scrollDistance * this.scrollSpeed;

    this.setTransforms(offset);
  }

  syncMobileMarquee() {
    this.mobileBehavior = this.section.dataset.mobileBehavior || 'stacked';
  }

  clearTransforms() {
    if (!this.firstColumn || !this.secondColumn) {
      return;
    }

    this.firstColumn.style.transform = '';
    this.secondColumn.style.transform = '';
  }

  setTransforms(offset) {
    this.firstColumn.style.transform = `translate3d(0, ${offset * -1}px, 0)`;
    this.secondColumn.style.transform = `translate3d(0, ${offset}px, 0)`;
  }
}

const initReviewsSections = () => {
  document.querySelectorAll('[data-reviews-section]').forEach((section) => {
    if (!section.reviewsParallax) section.reviewsParallax = new ReviewsParallax(section);
  });
};

document.addEventListener('DOMContentLoaded', initReviewsSections);
document.addEventListener('shopify:section:load', initReviewsSections);
